export default "<app-header></app-header>\r\n<app-homepage></app-homepage>"